// extracted by mini-css-extract-plugin
module.exports = {"year":"HistoriaItem_year__QLMHx","bullet":"HistoriaItem_bullet__tsJY1","line":"HistoriaItem_line__mLEJF","title":"HistoriaItem_title__2T7AK","text":"HistoriaItem_text__37X0g"};